var exports = {
  "oq": "LexicalSearchInput.module__editorShell___YzlLR1",
  "LL": "LexicalSearchInput.module__editable___YzlLR1",
  "FY": "LexicalSearchInput.module__paragraph___YzlLR1",
  "bI": "LexicalSearchInput.module__tokenBase___YzlLR1",
  "bV": "LexicalSearchInput.module__tokenKey___YzlLR1",
  "vA": "LexicalSearchInput.module__tokenValue___YzlLR1",
  "eT": "LexicalSearchInput.module__tokenUnapplied___YzlLR1",
  "GU": "LexicalSearchInput.module__tokenExclude___YzlLR1",
  "qf": "LexicalSearchInput.module__placeholder___YzlLR1",
};

module.exports = exports;
